#@export GliveBooking.Presenters.Booker

class GliveBooking.Presenters.Booker extends BookingV2.Presenters.Base

  module: 'glive-booking'

  constructor: ->
    BookingV2.Presenters.Base.apply this, arguments
    @localesBasePath = "#{@localesBasePath}_arse" if @isARSE

  toHash: ->
    error = @model.get('error')

    hash =
      error: error
      errorLoading: error is 'loading' or error is 'timeout'
      errorBooking: error is 'server' or error is 'not_found'
      errorSegmentNotAvailable: error is 'conflict'
      errorSegmentExpired: error is 'gone'
      myReservationsLink: "/users/#{@model.get('userId')}/reservations"
      myGrouponsLink: "/users/#{@model.get('userId')}/groupons"
      isOpen: @options.isOpen
      isLocked: @options.isLocked
      phoneRequired: @model.requirePhone()
      questionRequired: @model.requireQuestion()
      isARSE: @isARSE
      showNewOverlay: @options.showNewOverlay

    hash
